import moment from 'moment';
import { mapGetters } from 'vuex';
import PriceCardLocalisations from '../../lang/PriceCard';
import Accounting from '../../mixins/accounting';

require('./scss/product-details-simplified.scss');

export default {
    props: ['product', 'currencyIsChanging', 'showTermsAndConditions'],

    mixins: [Accounting],

    i18n: PriceCardLocalisations,

    template: `
    <ul class="product-details" v-if="product">
        <li>
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img :src="icon('excess')">
                </span>
            </span>
            <span>
                {{ $t('PriceCard.excess_liability') }}
                <strong v-if="currencyIsChanging">&hellip;</strong>
                <span v-else>
                    <strong>{{ insuranceExcessPrice(product )}}</strong>
                    <span class="old-price" v-if="basicProduct">({{ insuranceExcessPrice(basicProduct) }})</span>
                </span>
            </span>
        </li>
        <li>
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img :src="icon('security')">
                </span>
            </span>
            <span>
                {{ $t('PriceCard.security_deposit') }}
                <strong v-if="currencyIsChanging">&hellip;</strong>
                <span v-else>
                    <strong>{{ insuranceDepositPrice(product )}}</strong>
                    <span class="old-price" v-if="basicProduct">({{ insuranceExcessPrice(basicProduct) }})</span>
                </span>
            </span>
        </li>
        <li>
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img :src="icon('fuel')">
                </span>
            </span>
            <span>
                {{ $t('PriceCard.fuel_policy') }}
                <template v-if="product.fuel_policy == 'SL'">{{ $t('PriceCard.like_for_like') }}</template>
                <template v-if="product.fuel_policy == 'FF'">{{ $t('PriceCard.full_to_full') }}</template>
            </span>
        </li>
        <li>
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img :src="icon('mileage')">
                </span>
            </span>
            <span>
            <template v-if="mileageUnit == 'Miles'">
                <template v-if="product.mileage">
                    {{ $t('PriceCard.miles_per_rental', { mileage: product.mileage }) }}
                </template>
                <template v-else>
                    {{ $t('PriceCard.unlimited_mileage') }}
                </template>
            </template>
            <template v-else>
                <template v-if="product.mileage">
                    {{ $t('PriceCard.km_per_rental', { mileage: product.mileage }) }}
                </template>
                <template v-else>
                    {{ $t('PriceCard.unlimited_mileage_km') }}
                </template>
            </template>
            </span>
        </li>
        <li>
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img :src="icon('cancellation')">
                </span>
            </span>
            <span>
                <template v-if="product.type=='BAS'"> {{ $t('PriceCard.non_refundable') }}</template>
                <template v-else-if="product.type=='PMP' && cancellationUntil.isAfter()">
                    {{ $t('PriceCard.free_cancellation_until') }} {{ cancellationUntil.format('DD MMM') }}
                </template>
                <template v-else>
                    {{ $t('PriceCard.cancellation_in_line_with') }}&nbsp;<a @click.stop.prevent="showTermsAndConditions" href="#"><span v-html="$t('PriceCard.tcs')"></span></a>
                </template>
            </span>
        </li>
        <li v-if="product.type == 'BAS'">
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img :src="icon('non-amendable')">
                </span>
            </span>
            <span>
                <template>{{ $t('PriceCard.non_amendable') }}</template>
            </span>
        </li>
        <li v-if="product.type == 'PMP'">
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img :src="icon('extras')">
                </span>
            </span>
            <span>{{ $t('PriceCard.free_extras_on_collection') }}
            </span>
        </li>
        <li v-if="product.type == 'PMP'">
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img :src="icon('glass')">
                </span>
            </span>
            <span>{{ $t('PriceCard.glass_and_tyres_covered') }}
            </span>
        </li>
        <li v-if="product.debit_card == 'Y'">
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img :src="icon('debit-card')">
                </span>
            </span>
            <span>{{ $t('PriceCard.debit_card_deposit') }}
            </span>
        </li>
    </ul>`,

    computed: {
        cancellationUntil() {
            return moment(this.quote.utc_pickup_datetime).subtract(2, 'days');
        },
        mileageUnit() {
            try {
                return this.quote.pickup_location.data.country.data.mileage_type
            } catch (e) {
                return 'Kilometers';
            }
        },
        basicProduct() {
            try {
                return this.quote
                    .selected_vehicle.data
                    .vehicle.data
                    .products.data.find((product) => product.type == 'BAS');
            } catch (e) {
                return null;
            }
        },
        ...mapGetters({
            quote: 'getQuote',
            selectedCurrency: 'selectedCurrency',
        })
    },

    methods: {
        icon(name) {
            return `/images/svgs/${name}.svg`;
        }
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/Components/quotes/ProductDetailsSimplified.js